import React from 'react';
import PropTypes from 'prop-types';
import AssociatedBlockComponent from './AssociatedBlockComponent';
import { getContent } from '../../utils/formatValue';
const AssociatedItemsList = ({
    items,
    icon,
    primaryTitle,
    secondaryTitle,
    onRemove,
    primaryKey,
    secondaryKey,
    primaryType,
    secondaryType,
    hideSecondaryLabel
}) => {
    if (!items || items.length === 0) {
        return null;
    }

    return items.map((item, index) => (
        <AssociatedBlockComponent
            key={index}
            icon={icon}
            primaryTitle={primaryTitle}
            secondaryTitle={secondaryTitle}
            hideSecondaryLabel={hideSecondaryLabel}
            primaryContent={getContent(item, primaryKey, primaryType)}
            secondaryContent={getContent(item, secondaryKey, secondaryType)}
            action={{
                label: 'Remove',
                onClick: () => onRemove(item.id)
            }}
        />
    ));
};

AssociatedItemsList.propTypes = {
    items: PropTypes.array.isRequired,
    icon: PropTypes.node.isRequired,
    primaryTitle: PropTypes.string,
    secondaryTitle: PropTypes.string,
    onRemove: PropTypes.func.isRequired,
    primaryKey: PropTypes.string.isRequired,
    secondaryKey: PropTypes.string,
    primaryType: PropTypes.string,
    secondaryType: PropTypes.string
};

export default React.memo(AssociatedItemsList);
